<!-- eslint-disable -->
<template>
  <div class="preview-tab-container d-flex flex-column gap-3 h-100 w-100">
    <div class="card border-0 rounded-4 shadow-sm">
      <div class="card-body p-2 p-lg-3">
        <div class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-2 mb-2 workflow-preview-heading">
          <div>
            <h2 class="fw-bold mb-0 workflow-preview-title">Workflow Preview</h2>
          </div>
        </div>

        <div class="row g-2 mb-3">
          <div v-for="item in summaryCards" :key="item.label" class="col-12 col-sm-6 col-xl-4">
            <div class="card border rounded-4 h-100 workflow-metric-card">
              <div class="card-body p-2 position-relative overflow-hidden workflow-metric-body">
                <span class="workflow-metric-orb"></span>
                <p class="workflow-metric-label text-xxs text-uppercase fw-bold mb-2">{{ item.label }}</p>
                <p class="workflow-metric-value fw-bold mb-0">{{ item.value }}</p>
                <p v-if="item.caption" class="text-secondary text-xxs mb-0 mt-1">{{ item.caption }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-3 align-items-start">
          <div class="col-12 col-xl-8">
        <details class="preview-section card border rounded-4 shadow-sm mb-2 preview-tinted-card" open>
          <summary class="card-body p-2 preview-summary-header">
            <span class="fw-bold text-xs">Visual Status Flow</span>
            <span class="text-secondary text-xxs">{{ flowGroups.length }} source status{{ flowGroups.length === 1 ? '' : 'es' }}</span>
          </summary>
          <div class="px-2 pb-2">
            <div v-if="flowGroups.length" class="d-flex flex-column gap-2">
              <div v-for="group in flowGroups" :key="group.statusKey" class="preview-flow-group border rounded-4 p-2 preview-tinted-card">
                <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
                  <div class="d-flex align-items-center gap-2">
                    <i class="bi bi-circle-fill preview-flow-dot" :class="statusColorClass(group.color)"></i>
                    <div>
                      <p class="text-secondary text-xxs text-uppercase fw-bold mb-1">From Status</p>
                      <p class="fw-bold text-sm mb-0">{{ group.statusName }}</p>
                    </div>
                  </div>
                  <span v-if="group.terminal" class="badge rounded-pill bg-secondary-subtle text-secondary">Terminal Status</span>
                </div>
                <div class="d-flex flex-column gap-2">
                  <div v-for="transition in group.transitions" :key="transition.id" class="preview-flow-row border rounded-4 p-2 preview-tinted-card-soft">
                    <div>
                      <span class="badge rounded-pill mb-1" :class="transitionTypeBadgeClass(transition)">{{ transitionTypeLabel(transition) }} Transition</span>
                    </div>
                    <div class="preview-flow-action-center">
                      <span class="preview-action-chip">{{ transitionActionLabel(transition) }}</span>
                      <i class="bi bi-arrow-right text-secondary"></i>
                    </div>
                    <span class="badge bg-success-subtle text-success rounded-pill">{{ transition.target || 'Missing target' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <p v-else-if="transitions.length" class="text-secondary text-xxs mb-0">Transitions exist, but their source statuses are not matched to assigned statuses yet.</p>
            <p v-else class="text-secondary text-xxs mb-0">No transitions configured yet.</p>
          </div>
        </details>

        <details class="preview-section card border rounded-4 shadow-sm mb-2 preview-tinted-card" open>
          <summary class="card-body p-2 preview-summary-header">
            <span class="fw-bold text-xs">Transition Rule Summary</span>
            <span class="text-secondary text-xxs">{{ transitions.length }} rule{{ transitions.length === 1 ? '' : 's' }}</span>
          </summary>
          <div class="px-2 pb-2">
            <div v-if="transitionGroups.length" class="d-flex flex-column gap-2">
              <div v-for="group in transitionGroups" :key="`rule-group-${group.statusKey}`" class="card border rounded-4 preview-tinted-card">
                <div class="card-body p-2">
                  <p class="text-secondary text-xxs text-uppercase fw-bold mb-2">From: {{ group.statusName }}</p>
                  <div class="d-flex flex-column gap-2">
                    <div v-for="transition in group.transitions" :key="transition.id" class="border rounded-4 p-2 preview-tinted-card-soft">
                      <div class="d-flex flex-column flex-lg-row justify-content-between gap-3 mb-2">
                        <div>
                          <p class="fw-bold text-xs mb-1 d-flex align-items-center gap-2 flex-wrap">
                            <span class="preview-action-chip">{{ transitionActionLabel(transition) }}</span>
                            <i class="bi bi-arrow-right text-secondary"></i>
                            <span>{{ transition.target || 'Missing target' }}</span>
                          </p>
                          <p class="text-secondary text-xxs mb-0">{{ humanTransitionSentence(transition) }}</p>
                          <p class="fw-semibold text-xxs mb-0 mt-2">{{ transitionTypeExplanation(transition) }}</p>
                        </div>
                        <div class="d-flex flex-wrap gap-2 align-items-start">
                          <span class="badge rounded-pill" :class="transitionTypeBadgeClass(transition)">{{ transitionTypeLabel(transition) }}</span>
                          <span class="badge rounded-pill" :class="transition.isActive === false ? 'bg-secondary-subtle text-secondary' : 'bg-success-subtle text-success'">
                            {{ transition.isActive === false ? 'Inactive' : 'Active' }}
                          </span>
                        </div>
                      </div>
                      <div class="row g-2 text-xxs">
                        <div class="col-12 col-md-4"><span class="text-secondary">Minimum approvals:</span> <span class="fw-semibold">{{ transition.minApprovals || 1 }}</span></div>
                        <div class="col-12 col-md-8"><span class="text-secondary">Conditions:</span> <span class="fw-semibold">{{ readableConditionLabel(transition) }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p v-else class="text-secondary text-xxs mb-0">No transition rules have been configured.</p>
          </div>
        </details>

        <div class="row g-3">
          <div class="col-12 col-lg-6">
            <details class="preview-section card border rounded-4 shadow-sm h-100 preview-tinted-card" open>
              <summary class="card-body p-2 preview-summary-header">
                <span class="fw-bold text-xs">Reviewer Summary</span>
                <span class="text-secondary text-xxs">{{ assignedReviewers.length }} assigned</span>
              </summary>
              <div class="px-2 pb-2">
                <div v-if="reviewerGroups.length" class="d-flex flex-column gap-2">
                  <div v-for="group in reviewerGroups" :key="group.statusName" class="border rounded-4 p-2 preview-tinted-card">
                    <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
                      <p class="fw-bold text-xxs mb-0">Status: {{ group.statusName }}</p>
                      <span v-if="group.terminal" class="badge rounded-pill bg-secondary-subtle text-secondary">Terminal Status</span>
                    </div>
                    <p v-if="group.terminal" class="text-secondary text-xxs mb-0">No further transitions expected.</p>
                    <p v-if="group.automaticOnly" class="text-secondary text-xxs mb-0">No reviewers required. Automatic transitions move when conditions are met.</p>
                    <div v-else-if="group.reviewers.length">
                      <p class="text-secondary text-xxs mb-1">Reviewers:</p>
                      <div class="d-flex flex-wrap gap-2 mb-2">
                        <span v-for="reviewer in group.reviewers" :key="reviewer.key || reviewer.label" class="badge bg-primary-subtle text-primary rounded-pill">{{ reviewer.label }}</span>
                      </div>
                      <p class="text-secondary text-xxs mb-1">Approvals Required: <span class="fw-semibold">{{ group.minApprovals }}</span></p>
                      <p class="text-secondary text-xxs mb-1">Transition Actions:</p>
                      <div class="d-flex flex-wrap gap-2">
                        <span v-for="action in group.actions" :key="action" class="badge bg-success-subtle text-success rounded-pill">{{ action }}</span>
                      </div>
                    </div>
                    <p v-else-if="!group.terminal" class="text-secondary text-xxs mb-0">No reviewers assigned for this manual transition source.</p>
                  </div>
                </div>
                <p v-else class="text-secondary text-xxs mb-0">No reviewer assignments available in the current preview context.</p>
              </div>
            </details>
          </div>

          <div class="col-12 col-lg-6">
            <details class="preview-section card border rounded-4 shadow-sm h-100 preview-tinted-card" open>
              <summary class="card-body p-2 preview-summary-header">
                <span class="fw-bold text-xs">Section Access Summary</span>
                <span class="text-secondary text-xxs">{{ sectionAccessRows.length }} section{{ sectionAccessRows.length === 1 ? '' : 's' }}</span>
              </summary>
              <div class="px-2 pb-2">
                <div v-if="sectionAccessSummary.length" class="d-flex flex-column gap-2">
                  <div v-for="group in sectionAccessSummary" :key="group.reviewerName" class="border rounded-4 p-2 preview-tinted-card">
                    <p class="fw-bold text-xxs mb-3">{{ group.reviewerName }}</p>
                    <div class="d-flex flex-column gap-2">
                      <div v-for="section in group.sections" :key="section.sectionName" class="border rounded-4 p-2 preview-tinted-card-soft">
                        <p class="fw-semibold text-xxs mb-2">{{ section.sectionName }}</p>
                        <div class="d-flex flex-wrap gap-2">
                          <span v-for="action in section.actions" :key="action" class="badge bg-success-subtle text-success rounded-pill">
                            <i class="bi bi-check2 me-1"></i>{{ action }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="text-secondary text-xxs">
                  <p class="fw-bold text-xxs mb-1">No section permissions assigned yet.</p>
                  <p class="mb-0">Reviewers currently inherit no explicit permissions. Go to Section Access to configure reviewer permissions.</p>
                </div>
              </div>
            </details>
          </div>
          </div>
          </div>

          <aside class="col-12 col-xl-4">
            <div class="d-flex flex-column gap-3 preview-side-panel">
              <div v-if="validationItems.length" class="card border rounded-4 bg-warning-subtle">
                <div class="card-body p-3">
                  <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
                    <div>
                      <p class="fw-bold text-xs mb-1">Validation Results</p>
                      <p class="text-secondary text-xxs mb-0">{{ workflowHealth.detail }}</p>
                    </div>
                    <div class="d-flex flex-wrap gap-2">
                      <span v-if="validationSummary.error" class="badge rounded-pill bg-danger-subtle text-danger px-2 py-1">{{ validationSummary.error }} error{{ validationSummary.error === 1 ? '' : 's' }}</span>
                      <span v-if="validationSummary.warning" class="badge rounded-pill bg-warning text-dark px-2 py-1">{{ validationSummary.warning }} warning{{ validationSummary.warning === 1 ? '' : 's' }}</span>
                      <span v-if="validationSummary.info" class="badge rounded-pill bg-info-subtle text-info px-2 py-1">{{ validationSummary.info }} info</span>
                    </div>
                  </div>
                  <div class="d-flex flex-column gap-2">
                    <div v-for="item in validationItems" :key="item.key" class="preview-warning-row rounded-4 bg-white border p-2" :class="validationRowClass(item)">
                      <div class="d-flex align-items-center gap-2 mb-1">
                        <span class="badge rounded-pill" :class="validationBadgeClass(item)">{{ item.severity }}</span>
                        <p class="fw-bold text-xxs mb-0">{{ item.title }}</p>
                      </div>
                      <p class="text-secondary text-xxs mb-0">{{ item.message }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="card border rounded-4 bg-success-subtle">
                <div class="card-body p-3 d-flex align-items-center gap-3">
                  <span class="preview-status-dot bg-success"></span>
                  <div>
                    <p class="fw-bold text-xs mb-1">Ready for Review</p>
                    <p class="text-secondary text-xxs mb-0">No blocking workflow setup warnings were detected from the current configuration.</p>
                  </div>
                </div>
              </div>
              <slot name="preview-side"></slot>
            </div>
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import {
  assigned_form_label,
  condition_label,
  first_value,
  health_badge_class,
  health_icon,
  human_transition_sentence,
  is_automatic_transition,
  normalize_status,
  preview_validation_items,
  readable_condition_label,
  safe_array,
  safe_boolean,
  safe_number,
  safe_object,
  safe_string,
  section_access_summary,
  status_color_class,
  status_looks_terminal,
  transition_action_label,
  transition_matches_status,
  transition_type_explanation,
  trigger_label,
  validation_summary,
  workflow_health,
} from './previewTabHelpers';

function unknown_array(value) {
  const items = [];
  if (!Array.isArray(value)) return items;
  value.forEach((item) => {
    items.push(item);
  });
  return items;
}

export default {
  name: 'PreviewTab',
  props: {
    workflowName: { type: String, default: 'Workflow' },
    assignedForms: { type: Array, default: () => [] },
    assignedStatuses: { type: Array, default: () => [] },
    transitions: { type: Array, default: () => [] },
    assignedReviewers: { type: Array, default: () => [] },
    sectionAccessRows: { type: Array, default: () => [] },
    sectionAccessMatrix: { type: Object, default: () => ({}) },
    workflowActions: { type: Array, default: () => [] },
    selectedStatusId: { type: [String, Number], default: '' }
  },
  setup(props) {
    const prop_assigned_statuses = computed(() => {
      const raw_statuses = safe_array(props, 'assignedStatuses');
      const statuses = unknown_array(raw_statuses);
      return statuses;
    });
    const prop_transitions = computed(() => {
      const raw_transitions = safe_array(props, 'transitions');
      const transitions = unknown_array(raw_transitions);
      return transitions;
    });
    const normalizedStatuses = computed(() => {
      const statuses = unknown_array(prop_assigned_statuses.value);
      const transitions = unknown_array(prop_transitions.value);
      const normalized_statuses = statuses.map((status, index) => normalize_status(status, index, transitions));
      return normalized_statuses;
    });
    const manualTransitions = computed(() => {
      const transitions = unknown_array(prop_transitions.value);
      const manual_transitions = transitions.filter((transition) => !is_automatic_transition(transition));
      return manual_transitions;
    });
    const automaticTransitions = computed(() => {
      const transitions = unknown_array(prop_transitions.value);
      const automatic_transitions = transitions.filter((transition) => is_automatic_transition(transition));
      return automatic_transitions;
    });
    const reviewersAssigned = computed(() => {
      const reviewers = safe_array(props, 'assignedReviewers');
      return Array.isArray(reviewers) && reviewers.length ? 'Yes' : 'No';
    });
    const assignedFormLabel = computed(() => assigned_form_label(safe_array(props, 'assignedForms')));
    const terminalStatuses = computed(() =>
      normalizedStatuses.value.filter((status) => safe_boolean(status, 'terminal'))
    );
    const entryStatusLabel = computed(() => {
      const explicit = normalizedStatuses.value.find((status) =>
        safe_boolean(status, 'isInitial') || safe_boolean(status, 'is_initial') || safe_boolean(status, 'persistedInitial')
      );
      const noIncoming = normalizedStatuses.value.find((status) =>
        !safe_array(status, 'incoming').length && safe_array(status, 'outgoing').length
      );
      return safe_string(explicit, 'statusName')
        || safe_string(noIncoming, 'statusName')
        || safe_string(normalizedStatuses.value[0], 'statusName', 'Not set');
    });
    const workflowType = computed(() => {
      if (manualTransitions.value.length && automaticTransitions.value.length) return 'Hybrid Workflow';
      if (automaticTransitions.value.length) return 'Automatic Workflow';
      if (manualTransitions.value.length) return 'Manual Workflow';
      return 'Not configured';
    });
    const transitionsWithConditions = computed(() => {
      const transitions = unknown_array(prop_transitions.value);
      const transitions_with_conditions = transitions.filter((transition) => first_value(transition, ['conditionsSummary'], 'No conditions') !== 'No conditions');
      return transitions_with_conditions;
    });
    const flowGroups = computed(() =>
      normalizedStatuses.value
        .map((status) => ({
          statusKey: safe_string(status, 'statusKey'),
          statusName: safe_string(status, 'statusName'),
          color: safe_string(status, 'color'),
          terminal: safe_boolean(status, 'terminal'),
          transitions: safe_array(status, 'outgoing'),
        }))
        .filter((group) => safe_array(group, 'transitions').length)
    );
    const transitionGroups = computed(() => {
      const grouped = flowGroups.value.slice();
      const groupedIds = new Set(
        grouped.reduce(
          (items, group) => items.concat(safe_array(group, 'transitions').map((transition) => safe_string(transition, 'id'))),
          []
        )
      );
      const unmatched = prop_transitions.value.filter((transition) => !groupedIds.has(safe_string(transition, 'id')));
      if (unmatched.length) {
        grouped.push({
          statusKey: 'unmatched',
          statusName: 'Unmatched source status',
          color: '#64748b',
          terminal: false,
          transitions: unmatched,
        });
      }
      return grouped;
    });
    const reviewerGroups = computed(() =>
      normalizedStatuses.value
        .filter((status) => safe_array(status, 'outgoing').length || safe_boolean(status, 'terminal'))
        .map((status) => {
          const outgoing = safe_array(status, 'outgoing');
          return {
            statusName: safe_string(status, 'statusName'),
            reviewers: outgoing.some((transition) => !is_automatic_transition(transition)) ? safe_array(props, 'assignedReviewers') : [],
            automaticOnly: outgoing.length > 0 && outgoing.every((transition) => is_automatic_transition(transition)),
            terminal: safe_boolean(status, 'terminal'),
            minApprovals: Math.max(...outgoing.map((transition) => safe_number(transition, 'minApprovals', 1)), 1),
            actions: outgoing.filter((transition) => !is_automatic_transition(transition)).map((transition) => first_value(transition, ['actionTrigger', 'action'], 'Missing trigger')),
          };
        })
    );
    const sectionAccessSummary = computed(() =>
      section_access_summary(
        safe_array(props, 'sectionAccessRows'),
        safe_object(props, 'sectionAccessMatrix'),
        safe_array(props, 'workflowActions'),
        safe_array(props, 'assignedReviewers')
      )
    );
    const summaryCards = computed(() => [
      { label: 'Assigned Forms', value: safe_array(props, 'assignedForms').length },
      { label: 'Total Statuses', value: prop_assigned_statuses.value.length },
      { label: 'Total Transitions', value: prop_transitions.value.length },
      { label: 'Manual Transitions', value: manualTransitions.value.length },
      { label: 'Automatic Transitions', value: automaticTransitions.value.length },
      { label: 'Terminal Statuses', value: terminalStatuses.value.length },
    ]);
    const validationItems = computed(() =>
      preview_validation_items(
        safe_array(props, 'assignedForms'),
        safe_array(props, 'assignedStatuses'),
        prop_transitions.value,
        safe_array(props, 'assignedReviewers'),
        sectionAccessSummary.value,
        normalizedStatuses.value
      )
    );
    const validationSummary = computed(() => validation_summary(validationItems.value));
    const workflowHealth = computed(() => workflow_health(validationSummary.value));
    const healthBadgeClass = computed(() => health_badge_class(workflowHealth.value));
    const healthIcon = computed(() => health_icon(workflowHealth.value));

    return {
      normalizedStatuses,
      manualTransitions,
      automaticTransitions,
      reviewersAssigned,
      assignedFormLabel,
      summaryCards,
      terminalStatuses,
      entryStatusLabel,
      workflowType,
      transitionsWithConditions,
      flowGroups,
      transitionGroups,
      reviewerGroups,
      sectionAccessSummary,
      validationItems,
      validationSummary,
      workflowHealth,
      healthBadgeClass,
      healthIcon,
    };
  },
  methods: {
    statusLooksTerminal(status = {}) {
      return status_looks_terminal(status);
    },
    statusColorClass(color = '') {
      return status_color_class(color);
    },
    transitionMatchesStatus(transition, status, direction) {
      return transition_matches_status(transition, status, direction);
    },
    isAutomaticTransition(transition) {
      return is_automatic_transition(transition);
    },
    transitionTypeLabel(transition) {
      return is_automatic_transition(transition) ? 'Automatic' : 'Manual';
    },
    transitionTypeBadgeClass(transition) {
      return is_automatic_transition(transition) ? 'bg-info-subtle text-info' : 'bg-primary-subtle text-primary';
    },
    triggerLabel(transition) {
      return trigger_label(transition);
    },
    automaticTransitionText() {
      return 'Automatically moves when conditions are met';
    },
    conditionLabel(transition) {
      return condition_label(transition);
    },
    readableConditionLabel(transition) {
      return readable_condition_label(transition);
    },
    transitionActionLabel(transition) {
      return transition_action_label(transition);
    },
    transitionTypeExplanation(transition) {
      return transition_type_explanation(transition);
    },
    humanTransitionSentence(transition) {
      return human_transition_sentence(transition);
    },
    validationBadgeClass(item) {
      const severity = safe_string(item, 'severity');
      if (severity === 'ERROR') return 'bg-danger-subtle text-danger';
      if (severity === 'WARNING') return 'bg-warning text-dark';
      return 'bg-info-subtle text-info';
    },
    validationRowClass(item) {
      const severity = safe_string(item, 'severity');
      if (severity === 'ERROR') return 'preview-warning-row-error';
      if (severity === 'WARNING') return 'preview-warning-row-warning';
      return 'preview-warning-row-info';
    }
  }
};
</script>

<style scoped src="./PreviewTab.css"></style>

